import React from "react";

const Projects = () => {
  return (
    <div className="container mt-4">
      <style>{`
        .project-card { box-shadow:0 4px 15px rgba(0,0,0,0.1); border-radius:10px; }
      `}</style>

      <h4>Projects</h4>

      <div className="row">
        {[1,2,3,4,5,6].map(i => (
          <div key={i} className="col-md-4 mb-3">
            <div className="card p-3 project-card">
              <h6>Laravel App</h6>
              <small className="text-success">● On Going</small>
              <p className="small mt-2">Project description...</p>

              <div className="d-flex justify-content-between small">
                <div>Start<br/>15 Nov</div>
                <div>Deadline<br/>25 Dec</div>
              </div>

              <div className="progress mt-2">
                <div className="progress-bar" style={{width:"60%"}}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;